module.exports = __webpack_public_path__ + "img/nosort.ab8965c9.svg";